import React, { useState } from "react";
import { Alert, Container, Card, Form, Button } from "react-bootstrap";
import authApi from "../api/authApi";
import WhatsAppAPI from "../api/WhatsAppAPI";
import * as constants from "../constants/CONSTANT";

const Login = () => {
  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
    tcode: "",
  });
  const [show, setShow] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (credentials.email && credentials.password && credentials.tcode) {
        const result = await authApi.login(credentials);
        if (result.success) {
          sessionStorage.setItem("token", result.authToken);
          sessionStorage.setItem("r-t", result.refreshToken);
          sessionStorage.setItem("myimage", "/abdul-pathan.png");
          let settingResult = await WhatsAppAPI.fetchCompanySetting(
            "lead_status_setting",
          );
          sessionStorage.setItem(
            "lead_status",
            settingResult?.setting?.configuration ||
              JSON.stringify(constants.LEAD_STATUS_VALUES),
          );
          window.location.assign("/");
        } else {
          setShow(true);
          setErrorMessage(result.errors);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = (e) =>
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  const isFormValid =
    credentials.password?.trim() &&
    credentials.tcode?.trim() &&
    emailRegex.test(credentials.email);

  return (
    <div className="login-main-container">
      {/* Left Section: Login Form */}
      <div className="login-left-side">
        <div className="login-form-wrapper">
          <div className="text-center mb-4">
            <img
              src="https://admin.watconnect.com/public/demo/attachment/watconnect.png"
              style={{ width: "100px" }}
              alt="Logo"
              className="mb-4"
            />
            <h3 className="fw-bold text-dark">Welcome Back</h3>
            <p className="text-muted">
              Enter your credentials to access your account
            </p>
          </div>

          <Alert variant="danger" show={show} className="py-2 text-center">
            {errorMessage}
          </Alert>

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label className="fw-bold">Company Name</Form.Label>
              <Form.Control
                required
                type="text"
                name="tcode"
                onChange={handleChange}
                placeholder="e.g. WatConnect"
                value={credentials.tcode}
                className="modern-input"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="fw-bold">Email Address</Form.Label>
              <Form.Control
                required
                type="email"
                name="email"
                onChange={handleChange}
                placeholder="Enter your email"
                value={credentials.email}
                className="modern-input"
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label className="fw-bold">Password</Form.Label>
              <div className="position-relative">
                <Form.Control
                  required
                  type={showPassword ? "text" : "password"}
                  name="password"
                  onChange={handleChange}
                  placeholder="••••••••"
                  value={credentials.password}
                  className="modern-input"
                />
                <i
                  className={`fa ${showPassword ? "fa-eye" : "fa-eye-slash"} modern-eye`}
                  onClick={togglePasswordVisibility}
                ></i>
              </div>
            </Form.Group>

            <Button
              variant="success"
              disabled={!isFormValid}
              type="submit"
              className="w-100 modern-login-btn py-3"
            >
              Sign In
            </Button>
          </Form>

          <div className="mt-5 text-center">
            <p className="text-muted small">
              © 2025 iBirds Software Services Pvt. Ltd.
            </p>
          </div>
        </div>
      </div>

      {/* Right Section: Image (Hidden on mobile) */}
      <div className="login-right-side">
        {/* Background image CSS se handle hogi */}
      </div>
    </div>
  );
};

export default Login;
